import React from 'react';
import { default as PartnerAuthProvider } from './PartnerAuthStore';
import { default as ServiceProvider } from './ServiceStore';
import { default as ServiceSmallMoveProvider } from './ServiceSmallMoveStore';
import { default as ServiceFamilyMoveProvider } from './ServiceFamilyMoveStore';
import { default as PartnerSignUpProvider } from './PartnerSignUpStore';

export default function GlobalStore({ children }: { children: React.ReactElement }) {
    return (
        <ServiceFamilyMoveProvider>
            <ServiceSmallMoveProvider>
                <ServiceProvider>
                    <PartnerAuthProvider>
                        <PartnerSignUpProvider>{children}</PartnerSignUpProvider>
                    </PartnerAuthProvider>
                </ServiceProvider>
            </ServiceSmallMoveProvider>
        </ServiceFamilyMoveProvider>
    );
}
